const parseExpiration = (value) => {
  if (typeof value !== 'string' || value.trim() === '') {
    return Number.NaN;
  }

  return Date.parse(value);
};

export const hasValidStoredSession = (authState) => {
  const storedIsAuthenticated =
    authState?.isAuthenticated ?? localStorage.getItem('isAuthenticated') === 'true';
  const storedAccessToken = authState?.access ?? localStorage.getItem('access');
  const storedAccessExpiration =
    authState?.access_expiration ?? localStorage.getItem('access_expiration');
  const parsedAccessExpiration = parseExpiration(storedAccessExpiration);

  const hasAccessToken =
    typeof storedAccessToken === 'string' && storedAccessToken.trim().length > 0;
  const isTokenValid =
    hasAccessToken &&
    (!storedAccessExpiration ||
      Number.isNaN(parsedAccessExpiration) ||
      Date.now() < parsedAccessExpiration);

  return storedIsAuthenticated === true && isTokenValid;
};
